// helpers
import { ApiHelper } from 'shared/helpers/api';
import { getCMSURL, ROUTES } from 'shared/api/urls';
// @ts-ignore
import logger from 'shared/logger';

// defs
import { WebAppType } from 'shared/store/app/types';
import { WEB_APP_TYPE } from 'shared/constants';

// constants

const DOMAIN = 'fashion';
const PLATFORM = {
  [WEB_APP_TYPE.ANDROID]: 'app',
  [WEB_APP_TYPE.IOS]: 'app',
  [WEB_APP_TYPE.MWEB]: 'mobile',
  [WEB_APP_TYPE.DESKTOP]: 'desktop',
};

interface CMSPageProps {
  headers: Record<string, string>;
  pageId: string;
  isMobile?: boolean;
  webAppType: WebAppType;
}

export const getCMSPageData = ({
  headers,
  pageId,
  isMobile,
  webAppType,
}: CMSPageProps): Promise<object> => {
  const searchParams = new URLSearchParams('');
  const deviceType = isMobile ? PLATFORM[WEB_APP_TYPE.MWEB] : PLATFORM[WEB_APP_TYPE.DESKTOP];

  searchParams.append('deviceType', deviceType);
  searchParams.append('domainId', DOMAIN);
  searchParams.append('platform', PLATFORM[webAppType]);

  if (pageId) {
    searchParams.append('pageId', pageId);
  }

  const url = getCMSURL(ROUTES.CMS) + '?' + searchParams.toString();

  return ApiHelper(url, { headers })
    .then(async (response: Response) => {
      try {
        if (response.ok === false) {
          logger.error({ ERROR: response, METHOD_NAME: 'getCMSPageData' });
          return Promise.reject({ status: response.status, data: response });
        }

        return await response.json();
      } catch (e) {
        logger.error({
          message: 'try block failed',
          ERROR: e,
          METHOD_NAME: 'getCMSPageData',
        });
        return Promise.reject({ status: 500 });
      }
    })
    .catch((err) => {
      logger.error({ ERROR: err, METHOD_NAME: 'getCMSPageData' });
      return Promise.reject({ status: 500 });
    });
};
